import axios from 'axios';

const request = axios.create({ baseURL: process.env.VUE_APP_BASE_API_URL });

request.interceptors.request.use(
  async (config) => {
    const ret = { ...config };
    ret.headers = {
      Accept: 'application/json, application/octet-stream',
    };
    return ret;
  },
  (error) => Promise.reject(error),
);

request.interceptors.response.use((response) => response, (error) => Promise.reject(error));

const getUnauthorized = (params) => request.get(params.path);

const deleteUnauthorized = (params) => request.delete(params.path);

const patchUnauthorized = (params) => request.patch(params.path);

export { getUnauthorized, deleteUnauthorized, patchUnauthorized };
